<div class="teaserSquare">
  <boels-generic-link-wrapper
    role="button"
    [componentData]="teaserComponentData"
    [class.color--dark]="
      teaserComponentData.titleColor === backgroundColor.GREY
    "
    [showArrow]="false"
    [showLink]="false"
  >
    <div class="teaserSquare-container shadowBox">
      <div class="teaserSquare-image">
        <img
          [src]="mediaUrl"
          loading="lazy"
          [alt]="teaserComponentData.imageAltText"
        />
      </div>
    </div>
    <div class="teaserSquare-link-content">
      <div class="teaserSquare-link">
        <span class="title">{{ teaserComponentData.title }}</span>
      </div>
      <div class="teaserSquare-icon">
        <fa-icon class="small" [icon]="arrowRightIcon"></fa-icon>
      </div>
    </div>
  </boels-generic-link-wrapper>
</div>
